export enum RoleFormMessages {
  fieldName = "roleForm.fieldName",
  fieldDescription = "roleForm.fieldDescription",
  createRole = "roleForm.createRole",
  editRole = "roleForm.editRole",
  deleteRole = "roleForm.deleteRole",
  confirmDeleteTitle = "roleForm.confirmDeleteTitle",
  confirmDeleteMessage = "roleForm.confirmDeleteMessage"
}

export interface TranslationRoleFormMessages {
  [RoleFormMessages.fieldName]: string;
  [RoleFormMessages.fieldDescription]: string;
  [RoleFormMessages.createRole]: string;
  [RoleFormMessages.editRole]: string;
  [RoleFormMessages.deleteRole]: string;
  [RoleFormMessages.confirmDeleteTitle]: string;
  [RoleFormMessages.confirmDeleteMessage]: string;
}
